import { useQuery } from '@tanstack/react-query';
import Chart from 'react-apexcharts';
import { NavLink } from 'react-router-dom';

import { getUpcomingChecksSummaryQueryOptions } from '@/queries/checks';
import { getWorkspaceRoute } from '@/utils/routes';

import CheckCircleIcon from '../../legacy/components/icons/check-circle';
import WarningOctagonIcon from '../../legacy/components/icons/warning-octagon';
import WarningTriangleIcon from '../../legacy/components/icons/warning-triangle';

export const MaintenanceOverview = () => {
  const { data } = useQuery(getUpcomingChecksSummaryQueryOptions());

  const options = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    grid: {
      padding: {
        top: 15,
        bottom: 5,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '70%',
        },
      },
    },
    labels: ['In Schedule', 'Upcoming', 'Overdue'],
    dataLabels: {
      enabled: false,
    },
    legend: { show: false },
    // comparedResult: [2, -3, 8],
    stroke: { width: 0 },
    colors: ['rgb(95, 195, 96)', 'rgb(249, 146, 38)', 'rgb(227, 81, 77)'],
    tooltip: {
      custom: function ({ series, seriesIndex, w }: { series: number[]; seriesIndex: number; w: { globals: { labels: string[] } } }) {
        const value = series[seriesIndex];
        const label = w.globals.labels[seriesIndex];

        return `<div class="px-1 py-[2px] rounded text-xs text-white bg-default-text">${label}: ${value}</div>`;
      },
    },
  };

  const total = data ? Object.values(data).reduce((acc, cur) => acc + cur, 0) : 0;

  return data !== null ? (
    <div className="flex flex-col gap-2">
      <span className="text-xl leading-[30px] font-medium">Schedules Summary</span>

      <div className="card-body relative h-[180px] p-0">
        <NavLink to={getWorkspaceRoute('/schedules/checks')}>
          <Chart options={options} series={data ? [data.healthy, data.upcoming, data.overdue] : []} type="donut" height={173} />
        </NavLink>

        <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
          {total > 0 && <span className="pt-[5px] text-xl/[30px] font-bold">{total}</span>}
        </div>
      </div>

      <div className="flex text-center">
        <div className="flex h-[101px] w-1/3 flex-col gap-[5px]">
          <div className="flex justify-center pt-[10px]">
            <CheckCircleIcon size={20} className="text-default-green" />
          </div>
          <div className="flex h-[30px] items-center justify-center text-xl/[30px] font-bold">{data?.healthy || '--'}</div>
          <div className="text-secondary-text mb-0 h-[21px] text-sm/[21px] font-normal">In Schedule</div>
        </div>
        <div className="flex h-[101px] w-1/3 flex-col gap-[5px]">
          <div className="flex justify-center pt-[10px]">
            <WarningTriangleIcon size={20} className="text-default-orange" />
          </div>
          <div className="flex h-[30px] items-center justify-center text-xl/[30px] font-bold">{data?.upcoming || '--'}</div>
          <div className="text-secondary-text mb-0 h-[21px] text-sm/[21px] font-normal">Upcoming</div>
        </div>
        <div className="flex h-[101px] w-1/3 flex-col gap-[5px]">
          <div className="flex justify-center pt-[10px]">
            <WarningOctagonIcon size={20} className="text-default-red" />
          </div>
          <div className="flex h-[30px] items-center justify-center text-xl/[30px] font-bold">{data?.overdue || '--'}</div>
          <div className="text-secondary-text mb-0 h-[21px] text-sm/[21px] font-normal">Overdue</div>
        </div>
      </div>
    </div>
  ) : null;
};
